import React, { useState, useEffect } from "react";

function ConfirmationPage() {
  const [lastOrder, setLastOrder] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem("commandes");
    if (stored) {
      const allCommands = JSON.parse(stored);
      if (allCommands.length > 0) {
        // On prend le dernier élément du tableau
        const last = allCommands[allCommands.length - 1];
        setLastOrder(last);
      }
    }
  }, []);

  if (!lastOrder) {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <h2>Aucune commande trouvée</h2>
        <p>Veuillez repasser commande ou vérifier vos informations.</p>
      </div>
    );
  }

  // On affiche la dernière commande
  return (
    <div style={{
      maxWidth: "600px",
      margin: "0 auto",
      padding: "20px",
      textAlign: "center",
      backgroundColor: "#fafafa",
      border: "1px solid #ddd",
      borderRadius: "8px"
    }}>
      <h1>Paiement confirmé ✅</h1>
      <p>Merci pour votre commande, <strong>{lastOrder.nom}</strong> !</p>

      <div style={{
        backgroundColor: "#fff",
        border: "1px solid #ddd",
        borderRadius: "6px",
        padding: "1rem",
        margin: "1rem 0",
        textAlign: "left"
      }}>
        <h2 style={{ marginTop: 0 }}>Détails de la commande</h2>
        <p><strong>ID :</strong> {lastOrder.id}</p>
        <p><strong>Date :</strong> {lastOrder.date}</p>
        <p><strong>Montant :</strong> {lastOrder.montant} €</p>
        
        {lastOrder.selectedPointRelais && (
          <div style={{ marginTop: "1rem" }}>
            <strong>Point Relais :</strong>
            <p>{lastOrder.selectedPointRelais.Nom}</p>
            <p>{lastOrder.selectedPointRelais.Adresse1}</p>
            {lastOrder.selectedPointRelais.Adresse2 && (
              <p>{lastOrder.selectedPointRelais.Adresse2}</p>
            )}
            <p>
              {lastOrder.selectedPointRelais.CP}{" "}
              {lastOrder.selectedPointRelais.Ville}
            </p>
          </div>
        )}
      </div>

      <p>Nous préparons votre commande et vous tiendrons informé de son expédition.</p>

      <button
        onClick={() => window.location.href = "/"}
        style={{
          marginTop: "20px",
          backgroundColor: "#333",
          color: "#fff",
          padding: "0.75rem 1.25rem",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer"
        }}
      >
        Retour à l'accueil
      </button>
    </div>
  );
}

export default ConfirmationPage;
